import { CandidateListData } from '../../types';

export const candidateListData: CandidateListData = {
  filters: {
    search: '',
    timeRange: '0',
    region: 'all',
    location: 'all',
    stage: 'all',
    rankBy: 'date_applied',
    order: 'desc',
  },
  rows: [],
};
